// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"8":"11f6fe33","119":"b2300487","373":"b519145b"}[chunkId] + ".js";
};